<template>
    <div class="calendar products_list">
        <div class="container">
            <breadcrumbs :dom="crumbsItem" />
            <div class="calendar_content products collection" v-for="(item, index) in calendar" v-bind:key="index">
                <ProductItemBox :products="item" :products_title="companyName(item)" :type="item.TypeID"/>
            </div>
            <div class="searchResults" style="padding-bottom: 10px;" v-if="classNull">
                <div class="products collection">
                    <div class="cantsearch">
                        <div class="row justify-content-center">
                            <div class="col-auto">
                                <img :src="require(`@/assets/images/icon/noteice.svg`)">
                            </div>
                            <div class="col-10 col-lg-auto align-self-center">
                                此日期還沒安排課程，試試看點選紅色的日期當天有開課哦~
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import ProductItemBox from '@/components/calendar/ItemBox'
    import classApi from '@/api/class'
    import moment from 'moment'
    import _ from 'lodash';

    export default {
        name: 'Calendar',
        data() {
            return {
                crumbsItem: [{
                        text: '首頁',
                        to: {
                            name: 'home'
                        },
                    }, {
                        text: '課程表',
                        active: true
                    }
                ],
                calendar: [],
                currentPage: 1,
                perPage: 20,
                lastPage: false,
                routerMonth: null,
                routerDay: null,
                routerDate: null,
                classNull: true,
            }
        },
        components: {
            Breadcrumbs,
            ProductItemBox,
        },
        watch: {
            '$route.query'() {
                this.$route.query.date 
                    ? this.routerDate = this.$route.query.date
                    : this.routerDate = moment().startOf('month').format('YYYY/MM/DD')
                this.getDateList()
            }
        },
        created() {
            this.$route.query.date 
                ? this.routerDate = this.$route.query.date 
                : this.routerDate = moment().startOf('month').format('YYYY/MM/DD')
            this.getDateList();
        },
        methods: {
            companyName(item) {
                console.log(item)
                if (item[0].CompanyId == 'A0'){
                    return item[0].CompanyName
                } else if (item[0].CompanyId == 'B0'){
                    return item[0].CompanyName
                } else { // 其他家
                    if (item[0].CompanyName) {
                        return item[0].CompanyName
                    } else {
                        return ''
                    }
                }
            },
            getDateList() {
                let filter = {
                    DateBegin: this.routerDate,
                    QueryDay: 1,
                    CurrentPage: 1,
                    PerPage: 999,
                }
                classApi.queryDateList(filter, (data) => {
                    data
                        ? this.classNull = false
                        : this.classNull = true

                    let GroupBy   = _.groupBy(data, (item) => item.CompanyId)
                    this.calendar = GroupBy

                    // Object.keys(GroupBy).forEach(key => {
                    //     let value = GroupBy[key];
                    // });
                });
            },
        }
    }
</script>

